import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export const CTASection = ({
  label = "What We Do",
  heading = "We bring the strategy, structure and support your marketing needs to move properly.",
  copy = "From social media and content strategy to AI, websites and digital systems, Track Digital helps you build a clearer, more consistent online presence.",
}) => {
  return (
    <section className="td-container py-16 md:py-24" data-testid="cta-section">
      <Reveal className="rounded-3xl px-8 py-16 md:px-16 md:py-24 relative overflow-hidden" style={{ background: "#ECE9FF" }}>
        <div className="absolute -right-16 -bottom-20 w-72 h-72 rounded-full" style={{ background: "rgba(124,108,240,0.12)" }} />
        <div className="relative max-w-3xl">
          <span className="td-label block mb-6">{label}</span>
          <h2 className="text-3xl md:text-5xl font-semibold leading-[1.08] mb-6">{heading}</h2>
          <p className="text-[#4a4a55] text-lg leading-relaxed td-measure mb-10">{copy}</p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link to="/contact" data-testid="cta-primary" className="td-btn td-btn-primary">
              Book a Discovery Call <ArrowRight size={18} />
            </Link>
            <Link to="/services" data-testid="cta-secondary" className="td-btn td-btn-outline">
              Explore Services
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default CTASection;
